// Which theme a page is set in. There is no switch: the landing page opens at
// night and carries its own daylight further down (the canto acts in
// AlphaMessage and MobileLandingPage), and every other page is set in the
// daylight the landing page ends in. Pure, so the rule can be tested and
// mirrored by the pre-React bootstrap in public/index.html (keep the two in
// step).

export const NIGHT_PATHNAMES = ['/'];

export function resolveTheme({ pathname } = {}) {
  const normalized = (pathname || '/').replace(/\/+$/, '') || '/';
  return NIGHT_PATHNAMES.includes(normalized) ? 'dark' : 'light';
}
